import classNames from "classnames";

const ItemQtyCell = ({
  quantity,
  unitOfMeasurement,
  expanded = false,
  mobile = false,
  isWiderCol = false,
}: {
  quantity: number | string;
  unitOfMeasurement: string;
  expanded: boolean;
  mobile: boolean;
  isWiderCol: boolean;
}) => {
  switch (unitOfMeasurement) {
    case "m²":
      return (
        <td
          className={classNames(
            mobile ? (isWiderCol ? "u-col-5" : "u-col-3") : "u-col-2",
            expanded && !mobile ? "u-flex u-flex-items-center u-flex-content-center u-border-none u-borderbot0" : mobile ? "u-t-align-end" : "u-t-align-center"
          )}
        >
          {quantity} m<sup>2</sup>
        </td>
      );
    case "kg":
      return (
        <td
          className={classNames(
            mobile ? (isWiderCol ? "u-col-5" : "u-col-3") : "u-col-2",
            expanded && !mobile ? "u-flex u-flex-items-center u-flex-content-center u-border-none u-borderbot0" : mobile ? "u-t-align-end" : "u-t-align-center"
          )}
        >
          {quantity} kg
        </td>
      );
    case "l":
      return (
        <td
          className={classNames(
            mobile ? (isWiderCol ? "u-col-5" : "u-col-3") : "u-col-2",
            expanded && !mobile ? "u-flex u-flex-items-center u-flex-content-center u-border-none u-borderbot0" : mobile ? "u-t-align-end" : "u-t-align-center"
          )}
        >
          {quantity} l
        </td>
      );
    case "kom":
      return (
        <td
          className={classNames(
            mobile ? (isWiderCol ? "u-col-5" : "u-col-3") : "u-col-2",
            expanded && !mobile ? "u-flex u-flex-items-center u-flex-content-center u-border-none u-borderbot0" : mobile ? "u-t-align-end" : "u-t-align-center"
          )}
        >
          {quantity} kom
        </td>
      );
    case "m":
      return (
        <td
          className={classNames(
            mobile ? (isWiderCol ? "u-col-5" : "u-col-3") : "u-col-2",
            expanded && !mobile ? "u-flex u-flex-items-center u-flex-content-center u-border-none u-borderbot0" : mobile ? "u-t-align-end" : "u-t-align-center"
          )}
        >
          {quantity} m
        </td>
      );
    case "komplet":
      return (
        <td
          className={classNames(
            mobile ? (isWiderCol ? "u-col-5" : "u-col-3") : "u-col-2",
            expanded && !mobile ? "u-flex u-flex-items-center u-flex-content-center u-border-none u-borderbot0" : mobile ? "u-t-align-end" : "u-t-align-center"
          )}
        >
          {quantity} komplet
        </td>
      );
    case "rola":
      return (
        <td
          className={classNames(
            mobile ? (isWiderCol ? "u-col-5" : "u-col-3") : "u-col-2",
            expanded && !mobile ? "u-flex u-flex-items-center u-flex-content-center u-border-none u-borderbot0" : mobile ? "u-t-align-end" : "u-t-align-center"
          )}
        >
          {quantity} rola
        </td>
      );
    default:
      return (
        <td
          className={classNames(
            mobile ? (isWiderCol ? "u-col-5" : "u-col-3") : "u-col-2",
            expanded && !mobile ? "u-flex u-flex-items-center u-flex-content-center u-border-none u-borderbot0" : mobile ? "u-t-align-end" : "u-t-align-center"
          )}
        >
          {quantity}
        </td>
      );
  }
};

export default ItemQtyCell;
